// eslint-disable-next-line spaced-comment
///  <reference types="vite/client" />

export const hashStringToHue = (s: string): number => {
  let h = 0
  for (let i = 0; i < s.length; i++) {
    h = Math.imul(h, 31) + s.charCodeAt(i)
  }
  return Math.abs(h) % 360
}

export const getDevWorktreeInfo = () => {
  const branch = (import.meta.env.VITE_GIT_BRANCH as string | undefined) ?? ''
  const port = (import.meta.env.VITE_TUNA_DEV_PORT as string | undefined) || window.location.port
  return { branch: branch || 'unknown', port }
}

export const getDevTitle = (baseTitle: string) => {
  if (!import.meta.env.DEV) {
    return baseTitle
  }
  const { branch, port } = getDevWorktreeInfo()
  return `:${port} ${branch} — ${baseTitle}`
}
